export default function PesquisarOrdemServico(){
    return "Pesquisa Ordem de serviço"
}